export const MILLISECONDS_PER_SECOND = 1000;
export const MILLISECONDS_PER_MINUTE = 60000;

export const dateFromTotalSeconds = (totalSeconds: number) => new Date(totalSeconds * MILLISECONDS_PER_SECOND);
